import { useEffect } from "react";
import { useRoutes } from "react-router-dom";
import DisableDevtool from 'disable-devtool';
import "./App.css";

import { routes } from "./global/Routes";

import {
  initSystemFont,
  initTheme,
} from "./utils/reader/serviceUtils/launchUtil";

function App() {
  const element = useRoutes(routes());

  useEffect(() => {
    initTheme();
    initSystemFont();
    DisableDevtool({
      md5: 'b86834a67190b4a294b95f6c52c3eda2',
      disableMenu: false,
      disableCopy: false,
      disableCut: false,
      disablePaste: false,
      disableIframeParents: true,
      ondevtoolopen: (type, next) => {
        next();
        // window.location.href = 'about:blank';
      }
    });
  }, []);

  return <>{element}</>;
}

export default App;
